// extracted by mini-css-extract-plugin
export var xFullPage = "Layout-module--x-full-page--4rXnS";
export var xAlignCenterY = "Layout-module--x-align-center-y--dazXY";
export var xImgLogo = "Layout-module--x-img-logo--DhHby";
export var xTitle = "Layout-module--x-title--kw8Zv";
export var xClickable = "Layout-module--x-clickable--ghOry";